import React, { useState } from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
export const CTA = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: ''
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState('');
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(s => ({
      ...s,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.phone) {
      setFormError('Por favor completa todos los campos');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setFormError('Por favor ingresa un correo electrónico válido');
      return;
    }
    const emailBody = `
Nuevo contacto de VENTA desde la web MINGA:
Nombre: ${formData.name}
Email: ${formData.email}
Teléfono: ${formData.phone}
Mensaje: Quiere vender su propiedad con MINGA (tarifa fija).
    `.trim();
    const mailtoLink = `mailto:hola@somosminga.com?subject=Venta%20-%20Contacto%20desde%20web&body=${encodeURIComponent(emailBody)}`;
    window.location.href = mailtoLink;
    setFormData({
      name: '',
      email: '',
      phone: ''
    });
    setFormError('');
    setFormSubmitted(true);
    setTimeout(() => setFormSubmitted(false), 5000);
  };
  return <section id="pricing" className="py-10 sm:py-24 bg-white" data-id="element-17">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-18">
        <div className="relative rounded-lg sm:rounded-2xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-19">
          <div className="absolute inset-0" data-id="element-20">
            <svg className="absolute right-0 top-0 transform translate-y-[-10%] translate-x-[30%] lg:translate-x-[10%] opacity-20" width="404" height="784" fill="none" viewBox="0 0 404 784" data-id="element-21">
              <defs data-id="element-22">
                <pattern id="pattern-squares" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-23">
                  <rect x="0" y="0" width="4" height="4" fill="currentColor" data-id="element-24" />
                </pattern>
              </defs>
              <rect width="404" height="784" fill="url(#pattern-squares)" data-id="element-25" />
            </svg>
          </div>

          <div className="relative py-8 px-3 sm:py-16 sm:px-10 lg:px-16" data-id="element-26">
            <div className="lg:grid lg:grid-cols-2 lg:gap-8 items-center" data-id="element-27">
              {/* Texto */}
              <div data-id="element-28">
                <h2 className="text-xl sm:text-3xl font-extrabold text-white" data-id="element-29">
                  Vende con tarifa fija y un solo corredor (abiertos a canje)
                </h2>
                <p className="mt-2 text-sm sm:text-base text-blue-100" data-id="element-30">
                  Sin comisión al comprador. Proceso digital, tasación por 3 fuentes y marketing profesional.
                </p>
                <ul className="mt-4 space-y-1 sm:space-y-2 text-xs sm:text-sm text-blue-100" data-id="element-31">
                  <li className="flex items-start" data-id="element-32">
                    <span className="flex-shrink-0 h-4 w-4 sm:h-5 sm:w-5 rounded-full bg-blue-300 bg-opacity-30 flex items-center justify-center text-xs" data-id="element-33">
                      ✓
                    </span>
                    <span className="ml-2" data-id="element-34">Menos visitas: filtramos interesados reales</span>
                  </li>
                  <li className="flex items-start" data-id="element-35">
                    <span className="flex-shrink-0 h-4 w-4 sm:h-5 sm:w-5 rounded-full bg-blue-300 bg-opacity-30 flex items-center justify-center text-xs" data-id="element-36">
                      ✓
                    </span>
                    <span className="ml-2" data-id="element-37">Carpeta legal y municipal completa</span>
                  </li>
                  <li className="flex items-start" data-id="element-38">
                    <span className="flex-shrink-0 h-4 w-4 sm:h-5 sm:w-5 rounded-full bg-blue-300 bg-opacity-30 flex items-center justify-center text-xs" data-id="element-39">
                      ✓
                    </span>
                    <span className="ml-2" data-id="element-40">Fotos pro, tour virtual y plano</span>
                  </li>
                </ul>
              </div>

              {/* Formulario */}
              <div className="mt-6 lg:mt-0" data-id="element-41">
                <div className="bg-white rounded-lg shadow-xl p-4 sm:p-6" data-id="element-42">
                  <h3 className="text-lg sm:text-xl font-medium text-gray-900" data-id="element-43">Cuéntanos de tu propiedad</h3>
                  <p className="mt-1 text-xs sm:text-sm text-gray-600" data-id="element-44">
                    Te contactaremos para preparar la venta y definir el mejor plan.
                  </p>

                  {formSubmitted ? <div className="mt-3 sm:mt-5 bg-green-50 border border-green-200 rounded-md p-3 text-center" data-id="element-45">
                      <div className="flex items-center justify-center" data-id="element-46">
                        <CheckIcon className="h-4 w-4 sm:h-5 sm:w-5 text-green-500 mr-1 sm:mr-2" data-id="element-47" />
                        <span className="text-green-800 font-medium text-sm" data-id="element-48">Mensaje enviado correctamente</span>
                      </div>
                      <p className="mt-1 text-xs text-green-700" data-id="element-49">Se abrirá tu cliente de correo para enviar el mensaje.</p>
                    </div> : <form className="mt-3 sm:mt-5 space-y-2 sm:space-y-3" onSubmit={handleSubmit} data-id="element-50">
                      {formError && <div className="bg-red-50 border border-red-200 rounded-md p-1.5 text-xs text-red-600" data-id="element-51">
                          {formError}
                        </div>}
                      <div data-id="element-52">
                        <label htmlFor="name" className="sr-only" data-id="element-53">
                          Nombre completo
                        </label>
                        <input id="name" name="name" type="text" value={formData.name} onChange={handleInputChange} required className="block w-full px-3 py-1.5 sm:py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-blue-600 text-sm" placeholder="Nombre completo" data-id="element-54" />
                      </div>
                      <div data-id="element-55">
                        <label htmlFor="email" className="sr-only" data-id="element-56">
                          Correo electrónico
                        </label>
                        <input id="email" name="email" type="email" value={formData.email} onChange={handleInputChange} required className="block w-full px-3 py-1.5 sm:py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-blue-600 text-sm" placeholder="Correo electrónico" data-id="element-57" />
                      </div>
                      <div data-id="element-58">
                        <label htmlFor="phone" className="sr-only" data-id="element-59">
                          Número de teléfono
                        </label>
                        <input id="phone" name="phone" type="tel" value={formData.phone} onChange={handleInputChange} required className="block w-full px-3 py-1.5 sm:py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-blue-600 text-sm" placeholder="Número de teléfono" data-id="element-60" />
                      </div>
                      <div data-id="element-61">
                        <button type="submit" className="w-full flex items-center justify-center px-4 py-1.5 sm:py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600" data-id="element-62">
                          Quiero vender
                          <ArrowRightIcon className="ml-2 h-3 w-3 sm:h-4 sm:w-4" data-id="element-63" />
                        </button>
                      </div>
                    </form>}
                </div>
              </div>
              {/* /Formulario */}
            </div>
          </div>
        </div>
      </div>
    </section>;
};